import {OnQueryStartedFunctionAttrType} from "@/types/generic/OnQueryStartedFunctionAttr.type";
import {
    UpdatePassengerClassesRequestType,
    UpdatePassengerClassesResponseType
} from "@CheckOrder/api/types/UpdatePassengerClassesQuery.type";
import {
    setCheckOrderFatalError,
    setCheckOrderPassengers, setModalNotice,
    setPassengerDataUpdating,
    setTicket
} from "@CheckOrder/reducers/checkOrderSlice";
import {setError} from "@Reducers/pageSlice";
import handleNoLongerAvailablePassengerClasses from "@CheckOrder/api/functions/handleNoLongerAvailablePassengerClasses";

export default function updatePassengerClassesQuery(): OnQueryStartedFunctionAttrType<UpdatePassengerClassesRequestType, UpdatePassengerClassesResponseType> {
    return async (request, {dispatch, queryFulfilled}) => {
        dispatch(setPassengerDataUpdating(true))

        try {
            const response = await queryFulfilled
            if (response.meta.response.ok && !!response.data.checkOrder.ticket) {
                const {ticket, passengers} = response.data.checkOrder

                const {
                    noLongerAvailablePassengerClassesData,
                } = handleNoLongerAvailablePassengerClasses(ticket, request.selectedSingleClasses, request.selectedReturnClasses)

                if (noLongerAvailablePassengerClassesData.noLongerAvailableClasses.length) {
                    dispatch(setModalNotice({
                        type: "error",
                        name: "passengerClassNoLongerAvailable",
                        data: noLongerAvailablePassengerClassesData,
                    }))
                }

                dispatch(setTicket({ticket}))
                dispatch(setCheckOrderPassengers(passengers))
            }
        } catch (err) {
            dispatch(setCheckOrderFatalError(true))
            dispatch(setError({
                error: "Couldn't save passenger classes",
                info: `${request.selectedSingleClasses.map((c) => (c.id)).join(", ")} passenger classes couldnt be added to the ticket ${request.ticketCode}`,
            }))
        }
    }
}